// services/invoicing.service.ts
import { BaseCaptchaService } from '../../services/base-captcha.service';
import { InterfaceInvoiceLicense } from '../../interface/invoice/invoice.license';

export class InvoicingService extends BaseCaptchaService {
  private successFlag: boolean;

  constructor(private loader: HTMLElement | null) {
    super();
    this.successFlag = false;
  }

  public isSuccess(): boolean {
    return this.successFlag;
  }

  async generateInvoice(formData: FormData): Promise<any> {
    // Проверяем наличие данных капчи
    if (!this.hasCaptchaData()) {
      throw new Error('Капча не пройдена');
    }

    this.loader?.classList.add('active');

    try {
      this.addCaptchaToFormData(formData);
      const response = await fetch(
        `/api/invoicing`,
        {
          method: 'POST',
          body: formData,
          headers: { 'Authorization': 'true' }
        }
      );

      const data = await response.json();

      if (response.ok) {
        this.successFlag = true;
      }

      return data;
    } catch (error) {
      throw error;
    } finally {
      this.loader?.classList.remove('active');
    }
  }

  async getInvoiceLicense(): Promise<InterfaceInvoiceLicense[] | null> {
    this.loader?.classList.add('active');
    try {
      const response = await fetch(
        '/api/invoicing/licenses',
        {
          method: 'GET',
          headers: { 'Authorization': 'true' }
        }
      );

      if (!response.ok) {
        return null;
      }

      return await response.json();
    } catch (error) {
      return null;
    } finally {
      this.loader?.classList.remove('active');
    }
  }

  async confirmCodeEmail(email: string): Promise<any> {
    this.loader?.classList.add('active');
    const formData = new FormData();
    formData.append('email', email);
    try {
      const response = await fetch(
        `/api/send-confirmation-code`,
        {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': 'true',
          },
        }
      );

      if (!response.ok) {
        return null;
      }

      return await response.json();
    } catch (error) {
      return null;
    } finally {
      this.loader?.classList.remove('active');
    }
  }

  async validateConfirmationCode(guid: string, code: string): Promise<any> {
    this.loader?.classList.add('active');
    const formData = new FormData();
    formData.append('Guid', guid);
    formData.append('Code', code);
    try {
      const response = await fetch(
        `/api/validate-confirmation-code`,
        {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': 'true',
          },
        }
      );

      if (!response.ok) {
        return null;
      }

      return await response.json();
    } catch (error) {
      return null;
    } finally {
      this.loader?.classList.remove('active');
    }
  }
  async verifyCaptcha(
    formData: FormData
  ): Promise<Response | null> {// {valid: boolean; message?: string}
    try {
     this.addCaptchaToFormData(formData);
      const response = await fetch('/captcha/slider/verify', {
        method: 'POST',
        body: formData
      })

      return await response;
    } catch (error) {
      return null;
    }
  }
  async sendRequestManager(
    formData: FormData
  ): Promise<Response | null> {
    try {
      this.loader?.classList.add('active');
      this.addCaptchaToFormData(formData);
      const response = await fetch('/invoicing/bid', {
        method: 'POST',
        body: formData
      })
      this.resetCaptchaData();
      return await response;
    } catch (error) {
      return null;
    } finally {
      this.loader?.classList.remove('active');
    }
  }
}
